import React, { useEffect, useState } from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { ISession } from '../../../models/pro-sites';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import {
    IPrintWarrantyInput,
    IAccountData,
    IWarrantyCenterRequest,
    PrintWarrantyRequestDTO,
    PrintWarrantyErrors,
    RegisterWarrantyRequestDTO,
    WarrantySubmitRequest,
    RegisterWarrantyErrors,
} from '../../../models/warranty-center';
import './warranty-center.css';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import { FieldValidation, validate } from '../../../validation/validation';
import * as Validators from '../../../validation/validators';
import { loadSession } from '../../../store/session/session-actions';
import { loadDevice } from '../../../store/device/device-actions';
import { loadBillToAccounts } from '../../../store/account/account-actions';
import SelectInput from '../../inputs/select-input';
import { IAccountBillTo } from '../../../models/account';
import { IPatientDevice } from '../../../models/device';
import {
    getDeviceWarrantySummaryFileName,
    submitWarrantyRequest,
} from '../../../api/device-api';
import PrintWarranty from './print-warranty';
import { Navigation } from '../../../global-functions';
import RegisterWarranty from './register-warranty';
import WarrantyRequestSummaryModal from './warranty-request-summary';
interface IWarrantyCenterProps {
    session: ISession | null;
    billToAccounts: IAccountBillTo[] | null;
    loadBillToAccounts: () => Promise<void>;
    deviceData: IPatientDevice | null;
    loadDevice: (serialNumber: string) => Promise<void>;
    warrantyRequest: IWarrantyCenterRequest;
    printWarrantyInput: IPrintWarrantyInput;
    accountData: IAccountData;
}

export const WarrantyCenter = ({
    session,
    billToAccounts,
    loadBillToAccounts,
    deviceData,
    loadDevice,
    accountData,
}: IWarrantyCenterProps) => {
    const intl = useIntl();
    const [errorsState, setErrorsState] = useState<
        PrintWarrantyErrors | RegisterWarrantyErrors
    >({});
    //const [userAccountData, setUserAccountData] = useState({ ...accountData! });
    const [warrantyTypesState, setWarrantyTypesState] = useState([
        {
            name: 'Purchase a Warranty',
            code: 'Purchase a Warranty',
        },
        {
            name: 'Register a Standard Product',
            code: 'Register a Standard Product',
        },
        {
            name: 'Print Warranty Information',
            code: 'Print Warranty Information',
        },
    ]);
    const [warrantyRequestTypeState, setWarrantyRequestTypeState] = useState();
    const [registerWarrantyData, setRegisterWarrantyData] =
        useState<RegisterWarrantyRequestDTO>();
    const [warrantySubmitRequest, setWarrantySubmitRequest] =
        useState<WarrantySubmitRequest>({});
    const [serialNumber1, setSerialNumber1] = useState<string>();
    const [serialNumber2, setSerialNumber2] = useState<string>();
    const [serialNumber3, setSerialNumber3] = useState<string>();
    const [serialNumber4, setSerialNumber4] = useState<string>();
    const [serialNumber5, setSerialNumber5] = useState<string>();
    const [serialNumber6, setSerialNumber6] = useState<string>();
    const [shipToAccount, setShipToAccount] = useState<string>();
    const [hearingAidType1, setHearingAidType1] = useState<string>('');
    const [hearingAidType2, setHearingAidType2] = useState<string>('');
    const [hearingAidType3, setHearingAidType3] = useState<string>('');
    const [hearingAidType4, setHearingAidType4] = useState<string>('');
    const [hearingAidType5, setHearingAidType5] = useState<string>('');
    const [hearingAidType6, setHearingAidType6] = useState<string>('');
    const [serialNUmber1Error, setSerialNUmber1Error] =
        useState<boolean>(false);
    const [serialNUmber2Error, setSerialNUmber2Error] =
        useState<boolean>(false);
    const [serialNUmber3Error, setSerialNUmber3Error] =
        useState<boolean>(false);
    const [serialNUmber4Error, setSerialNUmber4Error] =
        useState<boolean>(false);
    const [serialNUmber5Error, setSerialNUmber5Error] =
        useState<boolean>(false);
    const [serialNUmber6Error, setSerialNUmber6Error] =
        useState<boolean>(false);
    const [fitDateVisibility, setFitDateVisibility] = useState<boolean>(false);
    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [contactName, setContactName] = useState<string>('');
    const [emailAddress, setEmailAddress] = useState<string>('');
    const [showSerialNumber2, setShowSerialNumber2] = useState<boolean>(false);
    const [saving, setSaving] = useState(false);
    const [validating, setValidating] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isNuEar, setIsNuEar] = useState(false);
    const [submissionSuccessful, setSubmissionSuccessful] = useState(false);
    const unspecifiedError: any =
        'An unspecified error occurred submitting Workshop Request.';
    const starkeyContactNumber = '1-800-328-8602';
    const strarkeyContactEmail = 'mailto:starkeysupport@starkey.com';
    const nuEarContactNumber = '1-800-626-8327';
    const nuEarContactEmail = 'mailto:Nuear_cs@nuear.com';
    useEffect(() => {
        loadBillToAccounts();
        console.log('loadbilltoaccounnts is called');
        setContactName(session!.firstName + ' ' + session!.lastName);
        setPhoneNumber(session!.contactInfo!.phone);
        setEmailAddress(session!.contactInfo!.email);
        setIsNuEar(window.location.href.includes('nuearpro'));
    }, []);
    useEffect(() => {
        if (serialNumber1) {
            console.log('useeffect - serialNumber1 - ' + serialNumber1);
            loadDevice(serialNumber1!);
        }
    }, [serialNumber1]);
    useEffect(() => {
        if (serialNumber2) {
            console.log('useeffect - serialNumber2 - ' + serialNumber2);
            loadDevice(serialNumber2!);
        }
    }, [serialNumber2]);
    useEffect(() => {
        if (serialNumber3) {
            console.log('useeffect - serialNumber3 - ' + serialNumber3);
            loadDevice(serialNumber3!);
        }
    }, [serialNumber3]);
    useEffect(() => {
        if (serialNumber4) {
            loadDevice(serialNumber4!);
        }
    }, [serialNumber4]);
    useEffect(() => {
        if (serialNumber5) {
            console.log('useeffect - serialNumber5 - ' + serialNumber5);
            loadDevice(serialNumber5!);
        }
    }, [serialNumber5]);
    useEffect(() => {
        if (serialNumber6) {
            console.log('useeffect - serialNumber6 - ' + serialNumber6);
            loadDevice(serialNumber6!);
        }
    }, [serialNumber6]);

    const onWarrantyRequestTypeChange = (event: any) => {
        const { name, value } = event.target;
        setWarrantyRequestTypeState(value);
    };

    const printWarrantyFieldValidations = [
        new FieldValidation('contactName', 'Contact Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Contact_Name' }),
                    }
                )
            ),
        ]),
        new FieldValidation('phoneNumber', 'Phone Number', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Phone_Number' }),
                    }
                )
            ),
        ]),
        new FieldValidation('serialNumber1', 'SERIAL NUMBER 1', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'SERIAL_NUMBER_1_UPPER' }),
                    }
                )
            ),
        ]),
    ];

    const registerWarrantyFieldValidations = [
        new FieldValidation('contactName', 'Contact Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Contact_Name' }),
                    }
                )
            ),
        ]),
        new FieldValidation('phoneNumber', 'Phone Number', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Phone_Number' }),
                    }
                )
            ),
        ]),
        new FieldValidation('serialNumber1', 'SERIAL NUMBER 1', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'SERIAL_NUMBER_1_UPPER' }),
                    }
                )
            ),
        ]),
        new FieldValidation('patientFirstName', 'Patient’s First Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Patients_First_Name' }),
                    }
                )
            ),
        ]),
        new FieldValidation('patientLastName', 'Patient’s Last Name', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Patients_Last_Name' }),
                    }
                )
            ),
        ]),
        new FieldValidation('fitDate', 'fit Date', [
            Validators.required(
                intl.formatMessage(
                    {
                        id: 'Required_Field_Message',
                        defaultMessage: '{0} is required',
                    },
                    {
                        0: intl.formatMessage({ id: 'Date_Sold_Fit' }),
                    }
                )
            ),
        ]),
    ];

    const formIsValid = (): boolean => {
        if (warrantyRequestTypeState === 'Print Warranty Information') {
            setValidating(true);

            const errors: PrintWarrantyErrors = validate(
                {
                    serialNumber1: serialNumber1,
                    phoneNumber: phoneNumber,
                    contactName: contactName,
                },
                printWarrantyFieldValidations
            );
            setErrorsState(errors);

            return Object.keys(errors).length === 0;
        } else if (warrantyRequestTypeState === 'Register a Standard Product') {
            setValidating(true);

            if (fitDateVisibility) {
                const errors: RegisterWarrantyErrors = validate(
                    {
                        serialNumber1: serialNumber1,
                        patientFirstName:
                            warrantySubmitRequest.PatientFirstName,
                        patientLastName: warrantySubmitRequest.PatientLastName,
                        fitDate: warrantySubmitRequest.fitDate,
                        phoneNumber: warrantySubmitRequest.ContactPhone,
                        contactName: warrantySubmitRequest.ContactName,
                    },
                    registerWarrantyFieldValidations
                );
                setErrorsState(errors);
                return Object.keys(errors).length === 0;
            } else {
                const errors: RegisterWarrantyErrors = validate(
                    {
                        serialNumber1: serialNumber1,
                        patientFirstName:
                            warrantySubmitRequest.PatientFirstName,
                        patientLastName: warrantySubmitRequest.PatientLastName,
                        phoneNumber: warrantySubmitRequest.ContactPhone,
                        contactName: warrantySubmitRequest.ContactName,
                    },
                    registerWarrantyFieldValidations
                );
                setErrorsState(errors);

                return Object.keys(errors).length === 0;
            }
        }
        return true;
    };

    const printWarrantyFormInvalid = () => {
        const errorLength = Object.keys(errorsState).length;
        if (deviceData) {
            return errorLength > 0 || !deviceData!.device;
        } else {
            return errorLength > 0;
        }
    };
    const registerWarrantyFormInvalid = () => {
        const errorLength = Object.keys(errorsState).length;
        return (
            errorLength > 0 ||
            serialNUmber1Error ||
            serialNUmber2Error ||
            serialNUmber3Error ||
            serialNUmber4Error ||
            serialNUmber5Error ||
            serialNUmber6Error
        );
    };
    const isNewNavigationEnabled = () => {
        return session!.features!.findIndex((f) => f.id === 6) > -1;
    };

    const submitPrintWarrantyRequest = async () => {
        try {
            setSaving(true);

            const dto: PrintWarrantyRequestDTO = {
                phoneNumber: phoneNumber,
                firstName: session!.firstName,
                lastName: session!.lastName,
                serialNumber1: serialNumber1,
                serialNumber2: showSerialNumber2
                    ? deviceData!.pairDevice.serialNumber
                    : '',
                account: shipToAccount,
            };

            const result = await getDeviceWarrantySummaryFileName(dto);
            const pdfFileName = result.data!.Body;
            if (pdfFileName !== null && pdfFileName !== undefined) {
                window.open('/services/warrantySummary/form/' + pdfFileName);
                setValidating(false);
                setSaving(false);
                setFormSubmitted(true);
                Navigation.pushExternal(
                    '/prosite/my-account/online-forms/warranty-center'
                );
            } else {
                setSaving(false);
            }
        } catch (error) {
            setSaving(false);
        }
    };
    const submitRegistration = async () => {
        const result = await submitWarrantyRequest(warrantySubmitRequest);
        if (result!.ok) {
            setSubmissionSuccessful(true);
            setValidating(false);
            setSaving(false);
            setFormSubmitted(true);
        } else {
            setSaving(false);
            setSaveError(unspecifiedError);
        }
    };

    const handleSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();
        setValidating(true);
        if (warrantyRequestTypeState === 'Register a Standard Product') {
            if (!formIsValid()) {
                return;
            }
            submitRegistration();
            setValidating(false);
        } else if (warrantyRequestTypeState === 'Print Warranty Information') {
            if (!formIsValid()) {
                return;
            }
            submitPrintWarrantyRequest();
            setValidating(false);
        }
    };
    const updateFormDataForPrintWarranty = (
        serialNumber: string,
        phoneNumber: string,
        shippingAccount: string,
        contactName: string
    ) => {
        setSerialNumber1(serialNumber);
        setPhoneNumber(phoneNumber);
        setShipToAccount(shippingAccount);
        setContactName(contactName);
    };
    const onClosingSummaryModal = () => {
        setSaving(false);
        setFormSubmitted(false);
        setRegisterWarrantyData((prevState) => ({
            ...prevState!,
            deviceData: null,
            validating: false,
        }));
    };
    const updateFormDataForRegistration = (
        serialNumber1: string,
        serialNumber2: string,
        serialNumber3: string,
        serialNumber4: string,
        serialNumber5: string,
        serialNumber6: string,
        serialNumber1ProductType: string,
        serialNumber2ProductType: string,
        serialNumber3ProductType: string,
        serialNumber4ProductType: string,
        serialNumber5ProductType: string,
        serialNumber6ProductType: string,
        aidType1: string,
        aidType2: string,
        aidType3: string,
        aidType4: string,
        aidType5: string,
        aidType6: string,
        billToAccount: string,
        shipToAccount: string,
        phoneNumber: string,
        contactName: string,
        email: string,
        patientFirstName: string,
        patientLastName: string,
        fitDate: Date | null,
        serialNUmber1Error: boolean,
        serialNUmber2Error: boolean,
        serialNUmber3Error: boolean,
        serialNUmber4Error: boolean,
        serialNUmber5Error: boolean,
        serialNUmber6Error: boolean,
        fitDateVisibility: boolean
    ) => {
        console.log('serialNumber1: ' + serialNumber1);
        console.log('serialNumber2: ' + serialNumber2);
        console.log('serialNumber3: ' + serialNumber3);
        console.log('serialNumber4: ' + serialNumber4);
        console.log('serialNumber5: ' + serialNumber5);
        console.log('serialNumber6: ' + serialNumber6);
        console.log('serialNumber1: ' + serialNumber1ProductType);
        console.log('serialNumber2: ' + serialNumber2ProductType);
        console.log('serialNumber3: ' + serialNumber3ProductType);
        console.log('serialNumber4: ' + serialNumber4ProductType);
        console.log('serialNumber5: ' + serialNumber5ProductType);
        console.log('serialNumber6: ' + serialNumber6ProductType);
        console.log('phoneNumber: ' + phoneNumber);
        console.log('contactName: THIS IS THE ONE' + contactName);
        console.log('email: ' + email);
        console.log('fitDate' + fitDate);

        setWarrantySubmitRequest({
            Action: warrantyRequestTypeState,
            SerialNumber1: serialNumber1,
            SerialNumber2: serialNumber2,
            SerialNumber3: serialNumber3,
            SerialNumber4: serialNumber4,
            SerialNumber5: serialNumber5,
            SerialNumber6: serialNumber6,
            SerialNumber1ProductType: serialNumber1ProductType,
            SerialNumber2ProductType: serialNumber2ProductType,
            SerialNumber3ProductType: serialNumber3ProductType,
            SerialNumber4ProductType: serialNumber4ProductType,
            SerialNumber5ProductType: serialNumber5ProductType,
            SerialNumber6ProductType: serialNumber6ProductType,
            BillTo: billToAccount,
            ShipTo: shipToAccount,
            ContactPhone: phoneNumber,
            ContactName: contactName,
            EmailAddress: email,
            PatientFirstName: patientFirstName,
            PatientLastName: patientLastName,
            fitDate: fitDate,
        });
        setSerialNumber1(serialNumber1);
        setSerialNumber2(serialNumber2);
        setSerialNumber3(serialNumber3);
        setSerialNumber4(serialNumber4);
        setSerialNumber5(serialNumber5);
        setSerialNumber6(serialNumber6);
        setSerialNUmber1Error(serialNUmber1Error);
        setSerialNUmber2Error(serialNUmber2Error);
        setSerialNUmber3Error(serialNUmber3Error);
        setSerialNUmber4Error(serialNUmber4Error);
        setSerialNUmber5Error(serialNUmber5Error);
        setSerialNUmber6Error(serialNUmber6Error);
        setFitDateVisibility(fitDateVisibility);
        setHearingAidType1(aidType1);
        setHearingAidType2(aidType2);
        setHearingAidType3(aidType3);
        setHearingAidType4(aidType4);
        setHearingAidType5(aidType5);
        setHearingAidType6(aidType6);
    };

    const ShowSerialNumber2Flag = (flag: boolean) => {
        setShowSerialNumber2(flag);
    };
    const onCloseWarrantyRequestSummary = () => {
        setSubmissionSuccessful(false);
        Navigation.pushExternal(
            '/prosite/my-account/online-forms/warranty-center'
        );
    };

    return (
        <div className="row">
            <div className="col-md-9">
                <form onSubmit={handleSubmit}>
                    <h1 className={isNuEar ? 'nuEar' : 'starkey'}>
                        {intl.formatMessage({
                            id: 'Warranty_Center',
                            defaultMessage: 'Warranty Center',
                        })}
                    </h1>
                    <div className="well clearfix">
                        <div className="form-horizontal" role="form">
                            <div className="form-group">
                                <label className="control-label col-sm-4">
                                    {intl.formatMessage({
                                        id: 'I_Want_To',
                                        defaultMessage: 'I Want To',
                                    })}
                                    :
                                </label>
                                <div className="col-sm-8 col-md-6">
                                    <SelectInput
                                        name="warrantyTypes"
                                        label=""
                                        fieldClassName="col-sm-8 col-md-10"
                                        options={warrantyTypesState.map(
                                            (st) => ({
                                                value: st.code,
                                                text: intl.formatMessage({
                                                    id: st.name.replace(
                                                        / /g,
                                                        '_'
                                                    ),
                                                    defaultMessage: st.name,
                                                }),
                                            })
                                        )}
                                        hasDefaultOption={true}
                                        defaultOption={'Select'}
                                        onChange={onWarrantyRequestTypeChange}
                                        value={warrantyRequestTypeState}
                                        required={false}
                                    />
                                </div>
                            </div>
                        </div>
                        {session &&
                            billToAccounts &&
                            warrantyRequestTypeState ===
                                'Print Warranty Information' && (
                                <PrintWarranty
                                    userContactName={contactName}
                                    userEmailAddress={emailAddress}
                                    userPhoneNumber={phoneNumber}
                                    deviceData={deviceData}
                                    billToAccounts={billToAccounts}
                                    accountData={accountData}
                                    validating={validating}
                                    updateFormData={
                                        updateFormDataForPrintWarranty
                                    }
                                    SetSerialNumber2Flag={ShowSerialNumber2Flag}
                                    errors={errorsState}
                                    country={session.country}
                                ></PrintWarranty>
                            )}
                        {session &&
                            billToAccounts &&
                            warrantyRequestTypeState ===
                                'Register a Standard Product' && (
                                <RegisterWarranty
                                    userContactName={contactName}
                                    userEmailAddress={emailAddress}
                                    userPhoneNumber={phoneNumber}
                                    deviceData={deviceData}
                                    billToAccounts={billToAccounts}
                                    accountData={accountData}
                                    validating={validating}
                                    updateFormData={
                                        updateFormDataForRegistration
                                    }
                                    errors={errorsState}
                                    country={session.country}
                                ></RegisterWarranty>
                            )}
                    </div>
                    {warrantyRequestTypeState ===
                        'Print Warranty Information' &&
                        printWarrantyFormInvalid() && (
                            <div className="alert alert-danger">
                                <span>
                                    <FormattedMessage id="Please_enter_into_before_submitting" />
                                </span>
                            </div>
                        )}
                    {warrantyRequestTypeState ===
                        'Register a Standard Product' &&
                        registerWarrantyFormInvalid() && (
                            <div className="alert alert-danger">
                                <span>
                                    <FormattedMessage id="Please_enter_into_before_submitting" />
                                </span>
                            </div>
                        )}
                    {warrantyRequestTypeState && (
                        <div className="gutter-top">
                            <button
                                id="save-changes"
                                type="submit"
                                className="btn btn-primary"
                            >
                                <span>
                                    {saving ? (
                                        <>
                                            {intl.formatMessage({
                                                id: 'Submitting_button_spinner',
                                                defaultMessage: 'Submitting',
                                            })}
                                            ...
                                        </>
                                    ) : (
                                        <>
                                            {intl.formatMessage({
                                                id: 'Submit_Warranty_Request',
                                                defaultMessage:
                                                    'Submit Warranty Request',
                                            })}
                                        </>
                                    )}
                                </span>
                            </button>
                        </div>
                    )}
                </form>
            </div>
            {submissionSuccessful && (
                <WarrantyRequestSummaryModal
                    onAccept={() => undefined}
                    onClose={() => {
                        onCloseWarrantyRequestSummary();
                    }}
                    hearingAidType1={hearingAidType1}
                    hearingAidType2={hearingAidType2}
                    hearingAidType3={hearingAidType3}
                    hearingAidType4={hearingAidType4}
                    hearingAidType5={hearingAidType5}
                    hearingAidType6={hearingAidType6}
                    warrantySubmitRequest={warrantySubmitRequest}
                    isNewNavigationEnabled={isNewNavigationEnabled()}
                    isNuEar={isNuEar}
                    country={session!.country}
                />
            )}

            {/* {submissionSuccessful && (
                <div className="col-md-9">
                    <div className="pull-right">
                        <a
                            id="revrecord"
                            className="btn btn-default verticalAlignBottom"
                            href={
                                isNewNavigationEnabled()
                                    ? '/prosite/my-account/order-history'
                                    : '/my-account/account-summary'
                            }
                        >
                            Review Recent Orders
                        </a>
                        <span className="padRight" />
                        <button
                            className="hidden-print"
                            onClick={() => window.print()}
                            style={{ paddingTop: '4px' }}
                        >
                            <i className="glyphicon glyphicon-print"></i>
                            <span>Print ...</span>
                        </button>
                    </div>
                    <h2>Your Request Has Been Submitted</h2>
                    <p>
                        <span>
                            Thank you for submitting your Warranty Request.
                        </span>
                    </p>
                    <div className="form-horizontal well">
                        <h3 className="warrantyType">
                            {warrantyRequestTypeState}
                        </h3>
                        {warrantyRequestTypeState !==
                            'Register a Standard Product' && (
                            <div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 1:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {serialNumber1}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 2:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {serialNumber2}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Hearing Aid Type:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType1}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Patient Name:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.PatientFirstName
                                            }{' '}
                                            {
                                                warrantySubmitRequest.PatientLastName
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        {warrantyRequestTypeState ===
                            'Register a Standard Product' && (
                            <div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 1:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber1
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType1}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 2:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber2
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType2}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 3:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber3
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType3}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 4:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber4
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType4}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 5:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber5
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType5}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        SERIAL NUMBER 6:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.SerialNumber6
                                            }
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Item Description:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {hearingAidType6}
                                        </p>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Patient Name:
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {
                                                warrantySubmitRequest.PatientFirstName
                                            }{' '}
                                            {
                                                warrantySubmitRequest.PatientLastName
                                            }
                                        </p>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        Date Sold / Fit:(hearing aids only)')
                                    </label>
                                    <div className="col-sm-8 col-md-6">
                                        <p className="form-control-static">
                                            {warrantySubmitRequest.fitDate!.getDate()}
                                            {'/'}
                                            {warrantySubmitRequest.fitDate!.getMonth()}
                                            {'/'}
                                            {warrantySubmitRequest.fitDate!.getFullYear()}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Bill To Account:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.BillTo}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Ship To Account:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ShipTo}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Contact Name:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ContactName}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Phone Number:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.ContactPhone}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                Email Address:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static">
                                    {warrantySubmitRequest.EmailAddress}
                                </p>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                P.O. Number:
                            </label>
                            <div className="col-sm-8 col-md-6">
                                <p className="form-control-static"></p>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
        billToAccounts: state.billToAccounts
            ? state.billToAccounts.data!
            : null,
        deviceData: state.deviceData ? state.deviceData.data! : null,
    };
};

const mapDispatchToProps = {
    loadSession,
    loadDevice,
    loadBillToAccounts,
};

const warrantyCenterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(WarrantyCenter);

export default warrantyCenterContainer;
